{
    "addToCart": "Aggiungi al carrello",
    "yes": "Sì",
    "no": "No",
    "login": "Accesso",
    "cancel": "Annullare",
    "close": "Chiudere",
    "couponApplied": "Sconto applicato!",
    "unappliedCoupon": {
        "title": "Sconto non applicato",
        "description": "Scansiona il prodotto corrispondente per ricevere lo sconto."
    },
    "done": "Terminare",
    "welcome": "Benvenuto",
    "welcomeScan": "Paga in modo facile e veloce con il self-checkout",
    "total": "Totale",
    "toPayment": "Pagare",
    "back": "Indietro",
    "quantityNeeded": "Quantità",
    "confirmCart": "Hai scansionato tutti gli articoli?",
    "interactWithTerminal": "Interagisci con il terminale di pagamento per finalizzare l’acquisto",
    "endTitle": "Acquisto riuscito!",
    "endSubtitle": "Tutto a posto. Ti ringraziamo per aver fatto acquisti con noi!",
    "feedbackQuestion": "Com’è stata la tua esperienza?",
    "endThanksForFeedback": "Ti ringraziamo per il tuo feedback!",
    "endSeeYouLater": "Non vediamo l’ora di rivederti.",
    "getReceipt": "Ricevuta",
    "scanQRCode": "Scansiona questo codice QR per scaricare la ricevuta digitale",
    "printReceipt": "Stampare la ricevuta",
    "receiptPrinted": "✔ Ricevuta stampata",
    "finalizeSession": "Terminare la sessione",
    "productNotFound": "Ops! Non riusciamo a trovare questo articolo",
    "okDismiss": "OK",
    "somethingWentWrong": "Qualcosa è andato storto",
    "pleaseTryAgain": "Riprovare per favore",
    "pleaseWait": "Un momento...",
    "tryAgain": "Riprovare",
    "reload": "Ricarica",
    "stillThere": "Sei ancora lì?",
    "continue": "Continuare",
    "startOver": "Ricominciare",
    "scan": "Scansiona un articolo per aggiungerlo al carrello",
    "wantToStartOver": "Sei sicuro di voler ricominciare?",
    "wantToStartOverDescription": "Tutti gli articoli nel carrello e gli sconti applicati verranno rimossi.",
    "changeLanguage": "Cambiare la lingua",
    "ageVerification": "Scansiona il tuo documento d’identità per verificare l’età",
    "scanId": "Per acquistare questo prodotto è necessario <strong>scansionare il proprio documento di identità</strong> per verificare la propria età.",
    "holdIdSteady": "<strong>Nota:</strong> Tenere il documento d’identità fermo verso lo scanner",
    "sorryCantSell": "Siamo spiacenti, non possiamo venderti questo prodotto.",
    "sorryCantSellDescription": "Possiamo vendere questo prodotto solo a persone maggiorenni",
    "invalidId": "Non siamo riusciti a scansionare il documento. Prova di nuovo, per favore",
    "verificationSuccessful": "Verifica riuscita!",
    "startShopping": "Inizia lo shopping",
    "startShoppingKitchen": "Ordinare cibo",
    "wantToDeleteLineItem": "Sei sicuro di voler eliminare l’articolo?",
    "wantToDeleteLineItemDescription": "Il prodotto verrà rimosso dal tuo carrello.",
    "promotionsDontWork": "<strong>Nota:</strong> i prodotti in promozione non funzionano ancora con il self-checkout.",
    "addToBasket": "Aggiungere",
    "promo": "Azione",
    "product": "Prodotto",
    "productAdded": "Prodotto aggiunto!",
    "product_other": "Prodotti",
    "operatorModeDialog": {
        "title": "Hai bisogno di aiuto?",
        "description": "Si prega di scansionare il proprio badge per ulteriori azioni."
    },
    "orderList": {
        "collapseDetails": "Collassa",
        "expandDetails": "Espandi",
        "details": "Detagli",
        "title": "Ordini"
    },
    "checkoutError": {
        "default": "Oops, il pagamento non è riuscito. Prova di nuovo, per favore.",
        "AbortedByUser": "Il pagamento è stato annullato, riprova.",
        "PaymentDeviceNotFound": "Non è stato possibile trovare un terminale di pagamento per questo SCO.",
        "CouponNotFound": {
            "title": "Coupon non trovato",
            "description": "Questo coupon non può essere applicato perché non è stato trovato."
        },
        "CouponNotApplicable": {
            "title": "Coupon non applicabile",
            "description": "Questo coupon non corrisponde a nessun articolo nel tuo carrello. Scansiona prima il prodotto."
        },
        "CouponExpired": {
            "title": "Coupon scaduto",
            "description": "Questo coupon non può essere applicato perché è scaduto."
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon già utilizzato",
            "description": "Questo coupon non può essere applicato perché è già stato utilizzato."
        },
        "CouponRedemptionFailed": {
            "title": "Applicazione del coupon fallita",
            "description": "Il coupon non ha potuto essere applicato. Riprova."
        }
    },
    "operatorMode": "Operatore mod",
    "operator": {
        "configuration": {
            "title": "Configurazione",
            "individualConfig": {
                "title": "Configurazione SCO"
            },
            "storeConfig": {
                "title": "Configurazione del punto vendita"
            },
            "status": {
                "label": "SCO abilitato",
                "confirmDisable": "Sei sicuro/a di voler disattivare il SCO?",
                "confirmEnable": "Sei sicuro/a di voler attivare il SCO?"
            },
            "cartCheck": {
                "label": "Controllo del carrello abilitato",
                "confirmDisable": "Sei sicuro di voler disattivare il controllo del carrello?",
                "confirmEnable": "Sei sicuro di voler attivare il controllo del carrello?"
            }
        },
        "hardware": {
            "title": "Hardware",
            "lamp": "Lampada",
            "printer": "Stampante",
            "scanner": "Scanner",
            "red": "Rosso",
            "green": "Verde",
            "print": "Stampa ricevuta fittizia",
            "clear": "Cancella",
            "blink": "Lampeggiare",
            "paymentTerminal": "Terminale di pagamento",
            "login": "Accesso",
            "paymentDeviceConfig": {
                "currentIp": "Indirizzo IP attuale",
                "ipLabel": "Nuovo indirizzo IP",
                "invalidIp": "Indirizzo IP non valido",
                "setIp": "Imposta IP",
                "probe": "Sonda",
                "probeSucceeded": "Sondaggio riuscito",
                "probeFailed": "Sondaggio fallito",
                "loginSucceeded": "Accesso riuscito",
                "loginFailed": "Accesso non riuscito: {{reason}}",
                "status": "Stato",
                "statuses": {
                    "ready": "Pronto",
                    "requiresLogin": "Accesso richiesto",
                    "unreachable": "Non raggiungibile"
                },
                "ipUpdated": "Indirizzo IP aggiornato",
                "ipUpdateFailed": "Impossibile aggiornare l'indirizzo IP: {{reason}}",
                "alterIp": "Modifica IP",
                "dialogTitle": "IP del terminale di pagamento",
                "close": "Chiudi"
            }
        },
        "systemInformation": {
            "title": "Informazioni sul sistema",
            "deviceId": "ID dispositivo",
            "cashRegisterId": "ID della cassa SAP",
            "paymentDeviceId": "ID del dispositivo di pagamento",
            "paymentDeviceIp": "IP del dispositivo di pagamento",
            "runningVersion": "Versione in esecuzione",
            "storeId": "ID negozio”",
            "productPresetIds": "ID preimpostazione prodotto",
            "kitchenMenuId": "ID The Kitchen menu",
            "tenant": "Inquilino"
        }
    },
    "order": "Ordine",
    "order_other": "Ordini",
    "insight": "Insight",
    "insight_other": "Insights",
    "insightGrouping": {
        "groupBy": "Gruppo per",
        "scoId": "Self-checkout",
        "category": "Categoria"
    },
    "productCategory": {
        "label": "Categoria",
        "ABF": "Rifiuti",
        "BTRM": "Risorse operative",
        "BUCH": "Libri",
        "CBAU": "Unità compatibile",
        "CH00": "CH Gestione contratti",
        "CONT": "Contenitore KANBAN",
        "COUP": "Coupon",
        "DIEN": "Servizio non ordinato",
        "DLU1": "Servizio ordinato",
        "EPA": "Pacchetto attrezzature",
        "ERSA": "Ricambi",
        "FERT": "Prodotto finito",
        "FGTR": "Bevande",
        "FHMI": "Ausiliari di produzione",
        "FOOD": "Alimenti (esclusi quelli freschi)",
        "FRIP": "Prodotti freschi",
        "HALB": "Prodotto semilavorato",
        "HAWA": "Merce",
        "HERS": "Parte del produttore",
        "HIBE": "Materiali ausiliari/operativi",
        "IBAU": "Gruppo di manutenzione",
        "INTR": "Intra materiale",
        "KMAT": "Materiale configurabile",
        "LEER": "Vuoti",
        "LEIH": "Materiale di imballaggio a rendere",
        "LGUT": "Vuoti (dopo VOLL)",
        "MODE": "Moda (stagionale)",
        "MPO": "Oggetto di pianificazione materiale",
        "NLAG": "Materiale non di magazzino",
        "NOF1": "Non alimentare",
        "PIPE": "Materiale della conduttura",
        "PLAN": "Merce (pianificata)",
        "PRES": "Stampa",
        "PROC": "Materiale di processo",
        "PROD": "Gruppo di prodotti",
        "ROH": "Materia prima",
        "TBAK": "Tabacco",
        "UNBW": "Materiale non valorizzato",
        "VBFO": "Materiale di consumo FOOD",
        "VERP": "Imballaggio",
        "VKHM": "Additivi",
        "VOLL": "Prodotto completo",
        "WERB": "Materiale pubblicitario",
        "WERT": "Materiale di valore",
        "WETT": "Prodotto concorrente",
        "ZAUF": "Voce di spesa",
        "ZAUS": "Numero di stampa",
        "ZFRG": "Spese di franchising",
        "ZGIF": "Carte regalo Ravita",
        "ZILV": "AGS: Contratto di servizio internazionale",
        "ZITP": "AGS: Progetti informatici",
        "ZLEI": "Leihgut Kiosk AG",
        "ZLOG": "Servizi Logistici",
        "ZMFE": "AGS: Commissione di gestione",
        "ZOBJ": "Stampa - Oggetto",
        "ZRAV": "Ravita PinCodes",
        "ZSER": "AGS: Articoli di servizio"
    },
    "totalRevenue": "Ricavi totali",
    "needReceipt": "<strong>Hai bisogno uno scontrino?</strong> Lo puoi trovare nell’app in Impostazioni > Cronologia degli acquisti",
    "orderNumber": "Ordine",
    "takeReceipt": "<strong>Importante</strong>: per favore, prendi il biglietto d'ordine e consegnala al personale per ritirare i tuoi articoli.",
    "kitchen": "Kitchen",
    "theKitchen": "The Kitchen",
    "kitchenMenu": {
        "backToCart": "Torna al carrello",
        "productUnavailable": "Non disponibile",
        "allergens": "Allergeni",
        "nutritionalInformation": "Ingredienti e origine",
        "productInformation": "Informazioni sul prodotto",
        "upsellingTitle": "Qualcos’altro con questo?"
    },
    "availableAtAvec": "Disponibile in questo avec",
    "kitchenDescription": "Premi il pulsante The Kitchen per aprire il menu",
    "unknown": "Non conosciuto",
    "dateRangePicker": {
        "from": "Da",
        "to": "A"
    },
    "outOfOrder": {
        "title": "Ops! C’è un problema ",
        "subtitle": "Il self-checkout è temporaneamente fuori uso, ma stiamo lavorando duramente per sistemarlo."
    },
    "cartCheckTriggered": "Il tuo carrello è stato selezionato casualmente per un controllo manuale. Attendi che il personale venga da te.",
    "cartError": {
        "Unknown": {
            "title": "Ops! C’è un problema. Riprova."
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon già utilizzato",
            "body": "Il coupon è già stato utilizzato. Controlla il coupon e riprova."
        },
        "ServiceNotSellable": {
            "title": "Utilizza una cassa con personale",
            "body": "Questo articolo può essere acquistato solo a una cassa con personale."
        },
        "CouponNotApplicable": {
            "title": "Coupon non applicabile",
            "body": "Questo coupon non corrisponde a nessun articolo nel tuo carrello. Scansiona prima il prodotto."
        }
    }
}
